import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagIR = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M33.12 18.479h-3.271c.027.36.042.722.042 1.087 0 2.418-.604 4.762-1.658 6.43-.325.515-.871 1.242-1.603 1.732v-9.25h-3.26v9.25c-.732-.49-1.278-1.217-1.603-1.732-1.054-1.668-1.658-4.012-1.658-6.43 0-.365.015-.728.042-1.087H16.88c-.021.357-.032.72-.032 1.087 0 6.704 3.58 11.956 8.152 11.956 4.571 0 8.152-5.252 8.152-11.956 0-.367-.011-.73-.032-1.087Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M10.326 11.957h3.261v2.173h3.261v-2.174h3.26v2.175h3.262v-2.175h3.26v2.175h3.262v-2.175h3.26v2.175h3.261v-2.175h3.261v2.175h7.845C43.476 5.768 34.912 0 25 0 15.09 0 6.525 5.768 2.481 14.13h7.845v-2.174Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M39.674 35.869v2.174h-3.26v-2.174h-3.261v2.174h-3.261v-2.174H26.63v2.174h-3.26v-2.174h-3.262v2.174h-3.26v-2.174h-3.262v2.174h-3.26v-2.174H2.48c4.044 8.362 12.608 14.13 22.52 14.13 9.91 0 18.475-5.768 22.519-14.13h-7.846Z"
}));
FlagIR.displayName = 'FlagIR';
export default withFlagWrapper(FlagIR);
//# sourceMappingURL=index.js.map